module.exports = __webpack_public_path__ + "static/media/tusd.cf3ae396.svg";